/**
 * @generated SignedSource<<df7c4a82bb91c438dd20061cdb35df0b>>
 * @relayHash a9cdeeaccd4b330108e99d2acd0b3c21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 486fe26ba179eeb48409415499a451f9646ee6f47d713692f03c7f753040899d

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraVersionIssuesSortField = "ASSIGNEE" | "CREATED" | "KEY" | "PRIORITY" | "STATUS" | "TYPE" | "%future added value";
export type JiraVersionIssuesStatusCategories = "DONE" | "IN_PROGRESS" | "TODO" | "%future added value";
export type JiraVersionWarningCategories = "FAILING_BUILD" | "OPEN_PULL_REQUEST" | "OPEN_REVIEW" | "UNREVIEWED_CODE" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraVersionIssuesFiltersInput = {
  assigneeAccountIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  epicIds?: ReadonlyArray<string> | null | undefined;
  searchStr?: string | null | undefined;
  statusCategories?: ReadonlyArray<JiraVersionIssuesStatusCategories> | null | undefined;
  warningCategories?: ReadonlyArray<JiraVersionWarningCategories> | null | undefined;
};
export type JiraVersionIssuesSortInput = {
  order?: SortDirection | null | undefined;
  sortByField?: JiraVersionIssuesSortField | null | undefined;
};
export type versionDetailPageRefetchQuery$variables = {
  filters?: JiraVersionIssuesFiltersInput | null | undefined;
  id: string;
  isDevopsFeatureDisabledInFedRamp: boolean;
  shouldIncludeDevOpsFieldsViaAgs: boolean;
  sortBy?: JiraVersionIssuesSortInput | null | undefined;
};
export type versionDetailPageRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion">;
  } | null | undefined;
};
export type versionDetailPageRefetchQuery = {
  response: versionDetailPageRefetchQuery$data;
  variables: versionDetailPageRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDevopsFeatureDisabledInFedRamp"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldIncludeDevOpsFieldsViaAgs"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "collapsedUis"
},
v9 = {
  "kind": "Literal",
  "name": "filter",
  "value": "ALL"
},
v10 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v11 = [
  (v10/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "canEdit"
},
v13 = {
  "kind": "ScalarField",
  "name": "status"
},
v14 = {
  "kind": "ScalarField",
  "name": "key"
},
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v17 = {
  "kind": "ScalarField",
  "name": "picture"
},
v18 = {
  "kind": "ScalarField",
  "name": "description"
},
v19 = [
  (v9/*: any*/),
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "sortBy"
  }
],
v20 = {
  "kind": "ScalarField",
  "name": "count"
},
v21 = {
  "kind": "ScalarField",
  "name": "state"
},
v22 = {
  "concreteType": "DevOpsSummarisedBuildState",
  "kind": "LinkedField",
  "name": "buildStates",
  "plural": true,
  "selections": [
    (v21/*: any*/),
    (v20/*: any*/)
  ]
},
v23 = [
  (v20/*: any*/)
],
v24 = {
  "kind": "ScalarField",
  "name": "title"
},
v25 = [
  (v20/*: any*/),
  (v7/*: any*/)
],
v26 = {
  "concreteType": "DevOpsSummarisedDeployments",
  "kind": "LinkedField",
  "name": "summarisedDeployments",
  "plural": false,
  "selections": (v25/*: any*/)
},
v27 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v28 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v29 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v30 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "versionDetailPageRefetchQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "versionDetailPageRefetchQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canAddAndRemoveIssues"
              },
              (v8/*: any*/),
              {
                "alias": "allIssues",
                "args": [
                  (v9/*: any*/)
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": (v11/*: any*/),
                "storageKey": "issues(filter:\"ALL\")"
              },
              (v12/*: any*/),
              {
                "kind": "ScalarField",
                "name": "startDate"
              },
              {
                "kind": "ScalarField",
                "name": "releaseDate"
              },
              (v13/*: any*/),
              {
                "kind": "ScalarField",
                "name": "versionId"
              },
              {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "projectId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cloudId"
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "maxHierarchyLevel": 1,
                          "minHierarchyLevel": 1
                        }
                      }
                    ],
                    "concreteType": "JiraIssueTypeConnection",
                    "kind": "LinkedField",
                    "name": "issueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueTypeHierarchyLevel",
                                "kind": "LinkedField",
                                "name": "hierarchy",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/)
                                ]
                              },
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "projectStyle"
                  }
                ]
              },
              {
                "concreteType": "JiraVersionDriverResult",
                "kind": "LinkedField",
                "name": "driverData",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "driver",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v16/*: any*/),
                      (v15/*: any*/),
                      (v17/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "queryError",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "message"
                      }
                    ]
                  }
                ]
              },
              (v18/*: any*/),
              (v15/*: any*/),
              {
                "concreteType": "JiraVersionWarningConfig",
                "kind": "LinkedField",
                "name": "warningConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "openPullRequest"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "openReview"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "unreviewedCode"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "failingBuild"
                  },
                  (v12/*: any*/)
                ]
              },
              {
                "concreteType": "JiraVersionConnectAddonIframeData",
                "kind": "LinkedField",
                "name": "connectAddonIframeData",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "appKey"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "appName"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "location"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "options"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canViewDevTools"
              },
              {
                "kind": "ScalarField",
                "name": "versionIssueTableHiddenColumns"
              },
              {
                "alias": "issuesForList",
                "args": (v19/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "jql"
                  },
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v7/*: any*/),
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "ids",
                                "value": [
                                  "priority",
                                  "summary",
                                  "assignee",
                                  "status",
                                  "issuetype"
                                ]
                              }
                            ],
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fieldsById",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "fieldId"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "statusCategoryId"
                                                  },
                                                  (v7/*: any*/)
                                                ]
                                              },
                                              (v7/*: any*/),
                                              (v15/*: any*/),
                                              (v18/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraStatusField"
                                      },
                                      (v7/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                              (v6/*: any*/),
                                              (v17/*: any*/),
                                              (v15/*: any*/),
                                              (v7/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraSingleSelectUserPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "text"
                                          }
                                        ],
                                        "type": "JiraSingleLineTextField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              {
                                                "concreteType": "JiraAvatar",
                                                "kind": "LinkedField",
                                                "name": "avatar",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "xsmall"
                                                  }
                                                ]
                                              },
                                              (v7/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraIssueTypeField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraPriority",
                                            "kind": "LinkedField",
                                            "name": "priority",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "iconUrl"
                                              },
                                              (v7/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraPriorityField"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "issueId"
                          },
                          {
                            "concreteType": "DevOpsSummarisedFeatureFlags",
                            "kind": "LinkedField",
                            "name": "summarisedFeatureFlags",
                            "plural": false,
                            "selections": (v11/*: any*/)
                          },
                          (v6/*: any*/),
                          {
                            "condition": "isDevopsFeatureDisabledInFedRamp",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "concreteType": "DevOpsSummarisedEntities",
                                "kind": "LinkedField",
                                "name": "devOpsSummarisedEntities",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "DevOpsSummarisedDeployments",
                                    "kind": "LinkedField",
                                    "name": "summarisedDeployments",
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "concreteType": "DevOpsEnvironment",
                                        "kind": "LinkedField",
                                        "name": "deploymentEnvironment",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "category"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "deploymentState"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "DevOpsSummarisedBuilds",
                                    "kind": "LinkedField",
                                    "name": "summarisedBuilds",
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/),
                                      (v7/*: any*/),
                                      (v22/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraIssueDevSummaryResult",
                                "kind": "LinkedField",
                                "name": "devSummaryCache",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueDevSummary",
                                    "kind": "LinkedField",
                                    "name": "devSummary",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "pullrequest",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/),
                                              (v21/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueBranchDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "branch",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueBranchDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": (v23/*: any*/)
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueReviewDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "review",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueReviewDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/),
                                              (v21/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "lastUpdated"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "stateCount"
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                            "kind": "LinkedField",
                                            "name": "summaryByProvider",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "providerId"
                                              },
                                              (v15/*: any*/),
                                              (v20/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueCommitDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "commit",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueCommitDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": (v23/*: any*/)
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueBuildDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "build",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueBuildDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "failedBuildCount"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "successfulBuildCount"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "unknownBuildCount"
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "deploymentEnvironments",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueDeploymentEnvironment",
                                                "kind": "LinkedField",
                                                "name": "topEnvironments",
                                                "plural": true,
                                                "selections": [
                                                  (v13/*: any*/),
                                                  (v24/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "DevOpsSummarisedFeatureFlags",
                                "kind": "LinkedField",
                                "name": "summarisedFeatureFlags",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "mostRelevantDisplayName"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "mostRelevantEnabled"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "mostRelevantRolloutPercentage"
                                  }
                                ]
                              },
                              {
                                "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  (v26/*: any*/),
                                  {
                                    "concreteType": "DevOpsSummarisedBuilds",
                                    "kind": "LinkedField",
                                    "name": "summarisedBuilds",
                                    "plural": false,
                                    "selections": [
                                      (v22/*: any*/),
                                      (v20/*: any*/),
                                      (v7/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v26/*: any*/),
                              {
                                "concreteType": "DevOpsSummarisedBuilds",
                                "kind": "LinkedField",
                                "name": "summarisedBuilds",
                                "plural": false,
                                "selections": (v25/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      (v27/*: any*/)
                    ]
                  },
                  (v28/*: any*/)
                ]
              },
              {
                "alias": "issuesForList",
                "args": (v19/*: any*/),
                "filters": [
                  "filter",
                  "sortBy",
                  "filters"
                ],
                "handle": "connection",
                "key": "ListVersion_issuesForList",
                "kind": "LinkedHandle",
                "name": "issues"
              },
              {
                "alias": "allIssuesRedesignTemp",
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": (v11/*: any*/)
              },
              (v8/*: any*/),
              {
                "args": (v29/*: any*/),
                "concreteType": "JiraVersionApproverConnection",
                "kind": "LinkedField",
                "name": "approvers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraVersionApproverEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraVersionApprover",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v15/*: any*/),
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                    "kind": "LinkedField",
                                    "name": "extendedProfile",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "jobTitle"
                                      }
                                    ]
                                  }
                                ],
                                "type": "AtlassianAccountUser"
                              },
                              (v7/*: any*/),
                              (v16/*: any*/)
                            ]
                          },
                          (v13/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "declineReason"
                          },
                          (v18/*: any*/),
                          (v30/*: any*/),
                          (v6/*: any*/)
                        ]
                      },
                      (v27/*: any*/)
                    ]
                  },
                  (v28/*: any*/)
                ],
                "storageKey": "approvers(first:100)"
              },
              {
                "args": (v29/*: any*/),
                "handle": "connection",
                "key": "version_approvers",
                "kind": "LinkedHandle",
                "name": "approvers"
              },
              {
                "concreteType": "JiraVersionRichTextSection",
                "kind": "LinkedField",
                "name": "richTextSection",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraADF",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "json"
                      }
                    ]
                  },
                  (v24/*: any*/)
                ]
              },
              {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "concreteType": "DevOpsSummarisedEntities",
                    "kind": "LinkedField",
                    "name": "devOpsSummarisedEntities",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "DevOpsProviders",
                        "kind": "LinkedField",
                        "name": "providers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "DevOpsFeatureFlagProvider",
                            "kind": "LinkedField",
                            "name": "featureFlagProviders",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v15/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "createFeatureFlagTemplateUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "connectFeatureFlagTemplateUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v30/*: any*/)
            ],
            "type": "JiraVersion"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "486fe26ba179eeb48409415499a451f9646ee6f47d713692f03c7f753040899d",
    "metadata": {},
    "name": "versionDetailPageRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "18efada2730a05c083b285addf6cb338";

export default node;
